import svgUrl from "ni:svgr;ml6eIXCX8g3X0E_9QUzoV5ZgMCFdHdw5ufpn7CR6YXA";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const FolderSourceMIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}><path fill="var(--tbl--colors--icons--misc--folder)" fillRule="evenodd" d="M5 4a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3h-6l-1.11-1.664A3 3 0 0 0 9.395 4H5Z" clipRule="evenodd" /><path fill="#fff" fillOpacity={0.3} d="M2 6a2 2 0 0 1 2-2h5.394a3 3 0 0 1 2.497 1.336L13 7H2V6Z" /></svg>;
const Memo = memo(FolderSourceMIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "FolderSourceMIcon";
}